module.exports = __webpack_public_path__ + "static/media/ErrorIcon.1520670c.svg";